import React, { useEffect, useState } from "react";
import { X, Download } from "lucide-react";
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useDelayedUnmount } from "../../../hooks/useDelayedUnmount";

const ImagePreviewModal = ({ src, onClose }) => {
  const visibility = useDelayedUnmount(Boolean(src), 200);
  const [displaySrc, setDisplaySrc] = useState(src || "");

  useEffect(() => {
    if (src) setDisplaySrc(src);
  }, [src]);

  if (!visibility.mounted || !displaySrc) return null;
  const handleDownload = (e) => {
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = displaySrc;
    const ext = displaySrc.match(/\.(png|jpg|jpeg|webp|gif|bmp)(\?|$)/i)?.[1] || 'png';
    link.download = `asset_${Date.now()}.${ext}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Dialog open={Boolean(src)} onClose={onClose} className="relative z-[100]">
      <DialogBackdrop
        transition
        className="ui-dialog-backdrop fixed inset-0 backdrop-blur-sm"
        style={{ backgroundColor: 'var(--color-bg-overlay)' }}
      />
      <div className="fixed inset-0 flex items-center justify-center p-4" onClick={onClose}>
        <button
          onClick={onClose}
          className="ui-pressable absolute top-4 right-4 p-2 rounded-full z-[110]"
          style={{ backgroundColor: 'var(--color-bg-tertiary)', color: 'var(--color-text-primary)' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-error)'; e.currentTarget.style.color = 'white'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-bg-tertiary)'; e.currentTarget.style.color = 'var(--color-text-primary)'; }}
          aria-label="关闭预览"
          title="关闭预览"
        >
          <X size={24} />
        </button>
        <DialogPanel
          transition
          className="ui-dialog-panel relative max-w-[90vw] max-h-[90vh]"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={displaySrc}
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            style={{ border: '1px solid var(--color-border-primary)' }}
            alt="preview"
          />
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
            <button
              onClick={handleDownload}
              className="ui-pressable flex items-center gap-2 px-6 py-2 rounded-full text-sm font-bold shadow-xl hover:scale-[1.02]"
              style={{ backgroundColor: 'var(--color-bg-tertiary)', color: 'var(--color-text-primary)', border: '1px solid var(--color-border-primary)' }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--color-border-hover)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.4)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border-primary)'; e.currentTarget.style.boxShadow = 'none'; }}
              aria-label="下载原图"
            >
              <Download size={16} /> 下载原图
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default ImagePreviewModal;
